/**
 * Marca a rota atual como conteúdo explícito para buscadores.
 *
 * É a marcação de primeira linha que o Google pede em
 * https://developers.google.com/search/docs/specialty/explicit/guidelines —
 * e a diretriz diz que, sem ela, "our systems might determine that your entire
 * site seems explicit in nature and filter the entire site when the SafeSearch
 * filter is on". Hoje o site inteiro é filtrado e a marcação não existe em
 * lugar nenhum, então páginas sem conteúdo adulto são ocultadas junto.
 *
 * Use SOMENTE em página que é de fato explícita. Marcar página que não é anula
 * o efeito de separação, que é justamente o que se quer obter aqui.
 *
 * `tagPriority` pelo mesmo motivo do `useNoIndex`: o `MetaTags.vue` global roda
 * DEPOIS do `<script setup>` da página, e no dedupe do unhead a última registrada
 * venceria. Abaixo de 100 o unhead elege pelo menor peso, de forma determinística.
 * Aqui não há default global de `rating` para vencer, mas o peso mantém o padrão
 * do projeto e protege caso um default seja acrescentado depois.
 */
export function useAdultRating() {
  useHead({
    meta: [
      { name: "rating", content: "adult", tagPriority: -10 },
    ],
  });
}
